export default "__VITE_ASSET__693d70f6__"